
import { Component, Vue } from 'vue-property-decorator'

export type StudentData = {
  acbtCode: string
  nickname: string
  branchName: string
  isPresenceStudied: boolean
}

@Component
export default class StudentListApis extends Vue {
  /**
   * 生徒一覧取得
   */
  protected async searchStudents(): Promise<StudentData[]> {
    const { data } = await Vue.prototype.$http.httpWithToken.get('/v1/branch/students')
    return data
  }
}
